import React, { useContext, useEffect } from "react";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { MDBCarousel, MDBCarouselItem, MDBBtn } from "mdb-react-ui-kit";
import { useNavigate } from "react-router-dom";
import axios from "../../context/axios";
import STcontext from "../../context/STcontext";
import ComptableContext from "../../context/ComptableContext";
import { Sync } from "@mui/icons-material";
import Select from "react-select";
import ImagePreview from "../../ImagePreview/ImagePreview";
import { Image } from "primereact/image";

export default function DetailsModel({ taskToUpdate }) {
   const { NewTask, showSuccessMessage, showErrorMessage } = useContext(STcontext);
   const { allCities } = useContext(ComptableContext);

   const [show, setShow] = useState(false);
   const handleClose = () => setShow(false);
   const navTo = useNavigate();
   const values = [true];
   const [is_loading, setIsLoading] = useState(false);
   const [is_sending, setIsSending] = useState(false);

   const [TaskToUpdateFromST, setTaskToUpdateFromST] = useState({
      garantie: taskToUpdate.garantie,
   });
   const [newDataTask, setNewDataTask] = useState([]);
   const [fullscreen, setFullscreen] = useState(true);
   const [images, setImages] = useState({
      imageUrl: "",
      id: 0,
   });

   const [technicians, setTechnicians] = useState([]);
   function handleShow(breakpoint) {
      fetchMoreDetailsOfTask();
      setFullscreen(breakpoint);
      setShow(true);
      setTaskToUpdateFromST(taskToUpdate);
   }

   const handelUpdateTaskFromST = (e) => {
      const { name, value } = e.target;
      setTaskToUpdateFromST({ ...TaskToUpdateFromST, [name]: value });
      setNewDataTask({ ...newDataTask, [name]: value });
   };
   const handleCheckBoxGrantie = (e) => {
      const name = e.target.name;
      setTaskToUpdateFromST({
         ...TaskToUpdateFromST,
         garantie: e.target.checked,
      });
      if (e.target.checked == false) {
         setNewDataTask({ ...newDataTask, [name]: "non" });
      } else {
         setNewDataTask({ ...newDataTask, [name]: e.target.checked });
      }
   };

   const fetchMoreDetailsOfTask = async () => {
      setIsLoading(true);
      try {
         const response = await axios.get(
            `/api/supportTechnique/getTaskDetails/${taskToUpdate.id}`
         );
         const taskData = response.data.task;
         setTaskToUpdateFromST(taskData);
         setIsLoading(false);
      } catch (error) {
         console.error("Error fetching task details:", error);
         setIsLoading(false);
      }
   }

   const updateTaskSubmit = async (e, id) => {
      e.preventDefault();
      setIsSending(true);
      try {
         const updateTaskSubmit = await axios.put(
            `api/supportTechnique/updateTask/${id}`,
            newDataTask
         );
         showSuccessMessage("La tâche a été mise à jour.");
         setIsSending(false);
         handleClose();
         setNewDataTask("");

      } catch (err) {
         setIsSending(false);
         showErrorMessage("La mise à jour a échoué pour cette tâche");
         console.log("error updating");
      }
   };

   const showImage = (imageUrl, id) => {
      setImages({ imageUrl, id });
   };
   const closeImageShow = () => {
      setImages({ imageUrl: "", id: 0 });
   };

   const defaultAccessories =
      TaskToUpdateFromST.vehicules &&
         TaskToUpdateFromST.vehicules.articles &&
         TaskToUpdateFromST.vehicules.articles
         ? TaskToUpdateFromST.vehicules.articles.map((acc) => {
            return {
               value: acc.id,
               label: acc.serial_number,
            };
         })
         : "";
   return (
      <div>
         <Button
            style={{ background: "none", color: "black", border: "none" }}
            onClick={() => handleShow(values)}
         >
            <VisibilityIcon />
         </Button>
         <Modal show={show} fullscreen={fullscreen} onHide={() => setShow(false)}>

            <Modal.Header closeButton>
               <Modal.Title>Détails tâche</Modal.Title>
            </Modal.Header>
            <Modal.Body
               style={{ gap: "20px", marginBottom: "10px", overflowY: "scroll" }}
            >
               {is_loading ? (
                  <div className="text-center p-5">
                     <div className="spinner-border" role="status">
                        <span className="visually-hidden">Chargement...</span>
                     </div>
                     <p>Chargement des détails...</p>
                  </div>
               ) : (
                  <Form
                     noValidate
                     method="POST"
                     onSubmit={(e) => updateTaskSubmit(e, TaskToUpdateFromST.id)}
                  >
                     <Row className="mb-3">

                        {/* NameClient */}
                        <Form.Group as={Col} md="3" controlId="validationCustom01">
                           <Form.Label>Nom client : </Form.Label>
                           <Form.Control
                              required
                              list="listClient"
                              type="text"
                              name="client_name"
                              autoComplete="off"
                              onChange={handelUpdateTaskFromST}
                              value={TaskToUpdateFromST.client_name}
                           />
                           <datalist id="listClient">
                              {NewTask.Clients.map((client) => (
                                 <option key={client.id}>{client.nomComplet}</option>
                              ))}
                           </datalist>
                        </Form.Group>

                        {/* matricule */}
                        <Form.Group as={Col} md="3" controlId="validationCustom02">
                           <Form.Label>Matricule : </Form.Label>
                           <Form.Control
                              type="text"
                              name="matricule"
                              onChange={handelUpdateTaskFromST}
                              value={TaskToUpdateFromST.matricule}
                           />
                        </Form.Group>

                        {/* type tache */}
                        <Form.Group as={Col} md="3" controlId="validationCustom02">
                           <Form.Label>Type du tâche : </Form.Label>
                           <Form.Control
                              list="typeTasks"
                              type="text"
                              name="catache"
                              autoComplete="off"
                              onChange={handelUpdateTaskFromST}
                              value={TaskToUpdateFromST.catache}
                           />
                           <datalist id="typeTasks">
                              {NewTask.TypesTasks.map((typeTask) => (
                                 <option key={typeTask.id}>{typeTask.catache}</option>
                              ))}
                           </datalist>
                        </Form.Group>

                        {/* IMEI */}
                        <Form.Group as={Col} md="3" controlId="validationCustom01">
                           <Form.Label>IMEI : </Form.Label>
                           <Form.Control
                              required
                              autoComplet="off"
                              type="text"
                              name="IMEI"
                              onChange={handelUpdateTaskFromST}
                              value={TaskToUpdateFromST.IMEI}
                           />
                        </Form.Group>
                     </Row>

                     <Row className="mb-3">
                        {/* model GPS */}
                        <Form.Group as={Col} md="3" controlId="validationCustom01">
                           <Form.Label>Modele Gps : </Form.Label>
                           <Form.Control
                              required
                              type="text"
                              name="nameModeleGPS"
                              onChange={handelUpdateTaskFromST}
                              value={TaskToUpdateFromST.nameModeleGPS}
                           />
                        </Form.Group>

                        {/* propreitaire GPS */}
                        <Form.Group as={Col} md="3" controlId="validationCustom01">
                           <Form.Label>Prop GPS : </Form.Label>
                           <Form.Select
                              list="proprietaireList"
                              required
                              type="text"
                              name="proprietaire"
                              onChange={handelUpdateTaskFromST}
                           >
                              <option value="none" selected disabled hidden>
                                 {TaskToUpdateFromST.proprietaire === 0
                                    ? "D3 hi-tech"
                                    : TaskToUpdateFromST.proprietaire === 1
                                       ? "Client"
                                       : "Proprietaire GPS"}
                              </option>
                              <option disabled>proprietaire</option>
                              <option value="DHT">D3 hi-tech</option>
                              <option value="client">Client</option>
                           </Form.Select>
                        </Form.Group>

                        {/* GPS Position */}
                        <Form.Group as={Col} md="3" controlId="validationCustom02">
                           <Form.Label>GPS Position: </Form.Label>
                           <Form.Select
                              type="text"
                              placeholder=""
                              name="GPSPosition"
                              onChange={handelUpdateTaskFromST}
                           >
                              <option value="none" selected disabled hidden>
                                 {TaskToUpdateFromST.gps_principale == 0
                                    ? "principale"
                                    : TaskToUpdateFromST.gps_principale == 1
                                       ? "secondaire"
                                       : "GPS Position"}
                              </option>
                              <option disabled>GPS Position</option>
                              <option value="principale">Première</option>
                              <option value="secondaire">Deuxième</option>
                           </Form.Select>
                        </Form.Group>

                        {/* model SIM */}
                        <Form.Group as={Col} md="3" controlId="validationCustom02">
                           <Form.Label>Modele SIM : </Form.Label>
                           <Form.Control
                              type="text"
                              placeholder=""
                              autoComplete="off"
                              name="nameModeleSIM"
                              onChange={handelUpdateTaskFromST}
                              value={TaskToUpdateFromST.nameModeleSIM}
                           />
                        </Form.Group>
                     </Row>

                     <Row className="mb-3">
                        {/* sim number */}
                        <Form.Group as={Col} md="3" controlId="validationCustom01">
                           <Form.Label>SIM : </Form.Label>
                           <Form.Control
                              required
                              type="text"
                              name="SIM"
                              onChange={handelUpdateTaskFromST}
                              value={TaskToUpdateFromST.SIM}
                           />
                        </Form.Group>

                        {/* propreitaire sim */}
                        <Form.Group as={Col} md="3" controlId="validationCustom02">
                           <Form.Label>Prop SIM : </Form.Label>
                           <Form.Select
                              type="text"
                              placeholder=""
                              name="SIM_proprietaire"
                              onChange={handelUpdateTaskFromST}
                           >
                              <option value="none" selected disabled hidden>
                                 {TaskToUpdateFromST.SIM_proprietaire === 0
                                    ? "D3 hi-tech"
                                    : TaskToUpdateFromST.SIM_proprietaire === 1
                                       ? "client"
                                       : "Sim Propreitaire"}
                              </option>
                              <option disabled>Sim Propreitaire</option>
                              <option value="internal">D3 HI-TECH</option>
                              <option value="client">client</option>
                           </Form.Select>
                        </Form.Group>
                        <Form.Group as={Col} md="3" controlId="validationCustom01">
                           <Form.Label>Type Relais : </Form.Label>
                           <Form.Control
                              required
                              type="text"
                              name="accesoriesModel"
                              onChange={handelUpdateTaskFromST}
                              value={
                                 TaskToUpdateFromST.vehicules &&
                                    TaskToUpdateFromST.vehicules.articles &&
                                    TaskToUpdateFromST.vehicules.articles.filter(
                                       (relais) => relais.modele_id === 21
                                    ).length > 0
                                    ? "Spécial"
                                    : TaskToUpdateFromST.vehicules &&
                                       TaskToUpdateFromST.vehicules.articles &&
                                       TaskToUpdateFromST.vehicules.articles.filter(
                                          (relais) => relais.modele_id === 22
                                       )
                                       ? "normal"
                                       : ""
                              }
                           />
                        </Form.Group>

                        <Form.Group as={Col} md="3" controlId="validationCustom02">
                           <Form.Label>Garantie : </Form.Label>
                           <Form.Check
                              type="checkbox"
                              label="sans"
                              name="garantie"
                              onClick={handleCheckBoxGrantie}
                              checked={
                                 TaskToUpdateFromST.garantie == 0
                                    ? true
                                    : TaskToUpdateFromST.garantie == 1
                                       ? false
                                       : ""
                              }
                           />
                        </Form.Group>
                     </Row>

                     <Row className="mb-3">
                        <Form.Group as={Col} md="3" controlId="validationCustom01">
                           <Form.Label>Exécutée par : </Form.Label>
                           <Form.Control
                              required
                              list="userList"
                              type="text"
                              name="user_name"
                              autoComplete="off"
                              onChange={handelUpdateTaskFromST}
                              value={TaskToUpdateFromST.user_name}
                           />
                           <datalist id="userList">
                              {NewTask.Users.filter((user) => user.profil_id === 1).map(
                                 (user) => (
                                    <option key={user.id}>{user.name}</option>
                                 )
                              )}
                           </datalist>
</Form.Group>
                         <Form.Group as={Col} md="3" controlId="validationCustom01">
                            <Form.Label>Réalisée à : </Form.Label>
                            <Form.Select
                               required
                               type="text"
                               name="clientCity"
                               autoComplete="off"
                               onChange={handelUpdateTaskFromST}
                            >
                               <option selected hidden>
                                  {TaskToUpdateFromST.cityName || "select ville"}
                               </option>
                               <option disabled>select Ville</option>
                               {allCities?.map((city, index) => (
                                  <option key={index} value={city.id}>
                                     {city.cityName}
                                  </option>
                               ))}
                            </Form.Select>
                         </Form.Group>
                         <Form.Group as={Col} md="3" controlId="validationCustom02">
                            <Form.Label>Date previsionnel debut : </Form.Label>
                           <Form.Control
                              type="datetime-local"
                              name="date_previsionnelle_debut"
                              onChange={handelUpdateTaskFromST}
                              value={TaskToUpdateFromST.date_previsionnelle_debut}
                           />
                        </Form.Group>
                        <Form.Group as={Col} md="3" controlId="validationCustom02">
                           <Form.Label>Date fin realisation : </Form.Label>
                           <Form.Control
                              type="datetime-local"
                              name="date_fin_realisation"
                              onChange={handelUpdateTaskFromST}
                              value={TaskToUpdateFromST.date_fin_realisation}
                           />
                        </Form.Group>
                        <Form.Group as={Col} md="3" controlId="validationCustom01">
                           <Form.Label>Observation : </Form.Label>
                           <Form.Control
                              as="textarea"
                              rows={3}
                              type="text"
                              name="observation"
                              onChange={handelUpdateTaskFromST}
                              value={TaskToUpdateFromST.observation}
                           />
                        </Form.Group>
                     </Row>
                     <Row className="mb-3 imageSlider" md="2">

                        {TaskToUpdateFromST.images
                           ? TaskToUpdateFromST.images.map((imagesTask) => (
                              <div className="flex justify-content-center" style={{ width: "auto" }}>
                                 <Image src={`${axios.defaults.baseURL}images/${imagesTask.url_imgtache}`} alt="Image" width="250" preview />                              </div>

                           ))
                           : ""}
                     </Row>
                     <Row className="mb-5 mt-5"><Col className="d-flex align-items-center justify-content-center">
                        <Button type="submit" variant="primary" disabled={is_sending}>
                           {is_sending ? (<>
                              <span
                                 className="spinner-border spinner-border-sm me-2"
                                 role="status"
                              ></span>
                              Enregistrement...
                           </>) : "Enregistrer les modifications"}
                        </Button>
                     </Col>
                     </Row>

                  </Form>
               )}

            </Modal.Body>
         </Modal>
      </div>
   );
}
